import React from "react";
import { SVG, IconProps } from "../SVG";

export const Healthcare = ({ color = "#13126C", strokeWidth = "2", ...props }: IconProps) => {
    return (
        <SVG viewBox="0 0 25 25" {...props}>
            <g id="Mu---FA-icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="2.0-Financial-Assistance" transform="translate(-922.000000, -631.000000)">
                    <g
                        id="Icon-/-Spot-/-Small-24-/-Cross"
                        transform="translate(923.000000, 632.000000)"
                    >
                        <rect
                            id="bounding-box"
                            fillOpacity="0"
                            fill="#FFFFFF"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                        ></rect>
                        <path
                            d="M15.9487179,1 L15.948,8.051 L23,8.05128205 L23,15.9487179 L15.948,15.948 L15.9487179,23 L8.05128205,23 L8.051,15.948 L1,15.9487179 L1,8.05128205 L8.051,8.051 L8.05128205,1 L15.9487179,1 Z"
                            id="Combined-Shape"
                            stroke={color}
                            strokeWidth={strokeWidth}
                            strokeLinejoin="round"
                        ></path>
                    </g>
                </g>
            </g>
        </SVG>
    );
};

Healthcare.displayName = "Healthcare";
